import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Stack,
  TextField
} from "@mui/material";
import { useMemo, useState } from "react";
import InternalUserAutocomplete from "../../shared/InternalUserAutocomplete";
import { InternalUser } from "../../types/app";
import { ClientOrder, Contact } from "../types/ClientOrder";

interface Props {
  openModal: boolean;
  setOpenModal: (e: any) => void;
  clientOrders: ClientOrder[];
  handleMultiUpdate:(orders: ClientOrder[], selectedContact: Contact[] | null, salesReps: InternalUser[] | null) => void;
  modalSaveLoading: boolean;
}
export default function MultiUpdateModal(props: Props) {
  const [selectedContacts, setSelectedContacts] = useState<Contact[]>([]);
  const [salesReps, setSalesReps] = useState<InternalUser[]>([]);

  const limit = 3;

  const commonContacts = useMemo(() => {
    if (props.clientOrders.length === 0) return [];

    return props.clientOrders
      .map((order) => order.contacts ?? [])
      .reduce((common, current) => common.filter((c) => current.some((cc) => cc.lookupCode === c.lookupCode)));
  }, [props.clientOrders]);

  return (
    <Dialog open={props.openModal} onClose={() => props.setOpenModal(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Multi Update</DialogTitle>

      <DialogContent sx={{ gap: 2, mt: 1 }}>
        <Stack direction={"row"} gap={2}>
        <Box width="100%">
          <Autocomplete
            multiple
            options={commonContacts}
            value={selectedContacts}
            onChange={(_, newValue) => setSelectedContacts(newValue)}
            getOptionLabel={(option) =>
              `${option.contactType} - ${option.name} ${`${option.isMarketingSource ? "⭐" : ""}`}`
            }
            isOptionEqualToValue={(option, value) => option.lookupCode === value.lookupCode}
            renderInput={(params) => <TextField {...params} label="Select Contact" placeholder="Select a contact" />}
          />
          </Box>
          <FormControl fullWidth>
            <Box width="100%">
              <InternalUserAutocomplete
                value={salesReps}
                onChange={(value) => {
                  // Limit selected option to max 3
                  value.length <= limit ? setSalesReps(value) : null;
                }}
                size="medium"
                label="Select Sales Person"
                multiple
                limitTags={2}
                limitToSalesReps
                getOptionDisabled={(option: InternalUser) => salesReps.length === limit}
              />
            </Box>
          </FormControl>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => props.setOpenModal(false)}>Cancel</Button>
        <Button
          variant="contained"
          disabled={props.modalSaveLoading}
          onClick={() => {
            props.handleMultiUpdate(props.clientOrders, selectedContacts, salesReps);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
